import {createSelector} from 'reselect'

import type {State} from '../../../../../reducers/types'
import {getCanShowAllProjects} from '../../../../../selectors/projectTrees'
import {shouldSaveSidebarSearchState} from '../../../../../utils/featureToggles'

import type {ProjectSidebarData} from './ProjectsSidebar.slices'

// If you change this function, update currentStorageVersion in persistState.ts and add the old version to oldStorageVersions
export const getProjectsSidebarStateToPersist: (state: State) => Partial<ProjectSidebarData> =
  createSelector(
    (state: State) => state.projectsSidebar,
    getCanShowAllProjects,
    ({activeItem, allProjectsCollapsed, ...sidebar}, canShowAllProjects) => ({
      ...(shouldSaveSidebarSearchState ? sidebar : {}),
      ...(canShowAllProjects ? {allProjectsCollapsed} : {}),
    }),
  )
